import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from '../operatori.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, map } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-update-functie-operator',
    templateUrl: './update-functie-operator.component.html',
    styleUrls: ['./update-functie-operator.component.scss']
})
export class UpdateFunctieOperatorComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    successIcon: string = environment.config.customNotifications.icons.success;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    functiiOperator$: any = [];

    token!: string;
    isLoading = true;

    form: FormGroup = new FormGroup({
        functie_id: new FormControl('-1', [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<UpdateFunctieOperatorComponent>,
        private notificationService: NotificationService,
        private commonService: CommonService,
        private authService: AuthService,
        private operatorService: OperatoriService
    ) {
        this.processToken();
        this.loadFunctii()
        this.loadFunctiiOperator();
    }

    loadFunctii() {
        console.log('this is actioned?')
        this.isLoading = true;
        this.functiiOperator$ = this.commonService.getFunctiiUserActiveList()
            .pipe(
                map((results: any) => {
                    return results
                }),
                finalize(() => {
                    this.isLoading = false;
                })
            );
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.operatorService.setToken(token);
        });
    }

    submitForm() {
        console.log('not implemented yet');
    }

    loadFunctiiOperator() {
        this.isLoading = true;
        this.operatorService
            .getOperatorFunctie(this.data.id_user)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (results: any) => {
                    this.form.patchValue({
                        functie_id: results.data.user_functie_id
                    })
                    console.log(results, 'check form')
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    updateFunctieOperator() {
        this.isLoading = true;
        this.operatorService
            .updateOperatorFunctie(this.data.id_user, this.form.value)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.success,
                        'Actualizare cu succes',
                        this.successIcon
                    );
                    this.closeDialog();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
